// Data fetching
export const GET_EXPENSE_DASHBOARD_REQUEST = 'GET_EXPENSE_DASHBOARD_REQUEST';
export const GET_EXPENSE_DASHBOARD_SUCCESS = 'GET_EXPENSE_DASHBOARD_SUCCESS';
export const GET_EXPENSE_DASHBOARD_FAILURE = 'GET_EXPENSE_DASHBOARD_FAILURE';
